module.exports = __webpack_public_path__ + "img/wooden-comb-engraving.jpg";